import { render } from "./IconView.vue?vue&type=template&id=16a09d52"
const script = {}

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconView.vue"]])

export default __exports__